<div id="logout" class="modal" materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-content text-left">
    <p [textContent]="'Are you sure you want to logout? You can log back in anytime and continue your application from where you left off.'"></p>
  </div>
  <div class="modal-footer text-right">
    <button type="button" (click)="closeModal()" class="btn btn-flat modal-btn modal-action modal-close waves-effect">Dismiss</button>
    <button type="button" (click)="logout()" class="btn zest-btn-2 modal-btn modal-action modal-close waves-effect">Logout</button>
  </div>
</div>
<div *ngIf="(showHeader == 1 || showHeader == 3)" class="fixed">
  <div class="zest-header">
    <div class="header row" id="zest-global-header">
      <div [class]="application?'col s8 m10 l3 logo-col' : 'col s4 m2 l3 logo-col'">
        <div class="brand-logos">
          <img class="zest-logo" src="../../assets/images/new-zest-logo.svg"/>
          <span class="with" *ngIf="application || (merchantConfig && merchantConfig.showLogoInHeader && merchantConfig.merchantName.length > 0)">with</span>
          <img class="merchant-logo" *ngIf="application" [src]="s3BucketUrl+'/logo-icons/'+(application.MerchantName|lowercase)+'-logo-icon.png'"
          />
          <img class="merchant-logo" *ngIf="!application && merchantConfig && merchantConfig.showLogoInHeader && merchantConfig.merchantName.length > 0"
            [src]="s3BucketUrl+'/logo-icons/'+(merchantConfig.merchantName|lowercase)+'-logo-icon.png'" />
        </div>
      </div>
      <div class="overlay-col">
        <div class="order-info" *ngIf="application">
          <span [class.text-bold]="showHeader == 1" [textContent]="showHeader == 1 ? 'ORDER ID' : 'Order Amount'"></span>
          <span class="order-id" [class.text-bold]="showHeader == 3" [textContent]="showHeader == 1 ? '#' + application.MerchantOrderId : (application.BasketAmount | RupeeCurrencyPipe)"></span>
        </div>
        <div materialize="dropdown" [materializeParams]="dropdownOptions" [class]="application ? 'hamburger-top dropdown-button icon' : 'dropdown-button icon'" data-activates='logout-dropdown'
          *ngIf="showLogout" (click)="trackClick()">
          <img src="../../../assets/images/hamburger.svg" alt="hamburger" />
        </div>
        <ul id='logout-dropdown' class='dropdown-content loan-info'>
          <li *ngIf="application && application.NumberOfInstallments > 0" class="loan-details">
            <div class="merchant-info">
              <img class="logo" *ngIf="application" [src]="s3BucketUrl+'/logo-icons/'+(application.MerchantName|lowercase)+'-logo-icon.png'"
              />
              <span class="summary">Summary</span>
            </div>
            <div class="amount">
              <div class="first-box">
                Loan Amount :
              </div>
              <div class="second-box">
                <span [textContent]="((application.BasketAmount - application.DownpaymentAmount) | RupeeCurrencyPipe)"></span>
              </div>
            </div>
            <div class="amount">
              <div class="first-box">
                EMI Plan :
                <span class="note">
                  incl. of interest
                </span>
              </div>
              <div class="second-box grey-border text-center">
                <span [textContent]="(application.TotalInstallmentAmount | RupeeCurrencyPipe)"></span>
                <span class="note" [textContent]="application.NumberOfInstallments + ' months'"></span>
              </div>
            </div>
          </li>
          <li *ngFor="let approvedApplication of approvedApplications" class="loan-details">
            <div class="merchant-info">
              <img class="logo" [src]="s3BucketUrl+'/logo-icons/'+(approvedApplication.MerchantName|lowercase)+'-logo-icon.png'" />
              <span class="summary">Summary</span>
            </div>
            <div class="amount">
              <div class="first-box">
                Loan Amount :
              </div>
              <div class="second-box">
                <span [textContent]="(approvedApplication.LoanAmount | RupeeCurrencyPipe)"></span>
              </div>
            </div>
            <div class="amount">
              <div class="first-box">
                EMI Plan :
                <span class="note">
                  incl. of interest
                </span>
              </div>
              <div class="second-box grey-border text-center">
                <span [textContent]="(approvedApplication.EmiAmount | RupeeCurrencyPipe)"></span>
                <span class="note" [textContent]="approvedApplication.NumberOfMonths + ' months'"></span>
              </div>
            </div>
          </li>
          <li *ngIf="concurrencyStatus">
            <a (click)="goToYourAccounts()">
              <i class="material-icons">account_circle</i>Your account</a>
          </li>
          <li *ngIf="showContact && width && width <= 768">
            <a href="tel:+919343422556" (window:resize)="onResize()">
              <i class="material-icons">phone</i>Contact Zest</a>
          </li>
          <li *ngIf="showContact && width && width > 768">
            <a (window:resize)="onResize()">
              <i class="material-icons">phone</i>+919343422556</a>
          </li>
          <li>
            <a (click)="showModal()">
              <i class="material-icons">power_settings_new</i>Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<nav *ngIf="(showHeader === 2 || showHeader === 4)" class="fixed">
  <div class="nav-wrapper">
    <div class="zest-header">
      <a href="http://www.zestmoney.in" target="_blank" class="brand-logo" [class.center]="showHeader === 2">
        <img src="../../../assets/images/new-zest-logo.svg" alt="zestmoney logo" class="logo-dimensions" />
      </a>
      <div class="overlay-col">
        <div materialize="dropdown" [materializeParams]="dropdownOptions" class='dropdown-button icon' data-activates='logout-dropdown'
          *ngIf="showLogout">
          <img src="../../../assets/images/hamburger.svg" alt="hamburger" />
        </div>
        <ul id='logout-dropdown' class='dropdown-content'>
          <li *ngIf="concurrencyStatus">
            <a (click)="goToYourAccounts()">
              <i class="material-icons">account_circle</i>Your account</a>
          </li>
          <li *ngIf="showContact && width && width <= 768">
            <a href="tel:+919343422556" (window:resize)="onResize()">
              <i class="material-icons">phone</i>Contact Zest</a>
          </li>
          <li *ngIf="showContact && width && width > 768">
            <a (window:resize)="onResize()">
              <i class="material-icons">phone</i>+919343422556</a>
          </li>
          <li>
            <a (click)="showModal()">
              <i class="material-icons">power_settings_new</i>Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>